import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'gatsby';
import cx from 'classnames';

import { useScrollFreeze } from '@hooks';
import { Arrow } from '@svg/arrow';
import { PageLink } from '../ui';
import Close from '@svg/close.svg';

const navVars = {
  open: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  closed: {
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
};

const homeVars = {
  initial: {
    opacity: 1,
    x: '-100vw',
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  exit: {
    x: '-100vw',
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
};

const linkVars = {
  initial: {
    opacity: 1,
    x: '100vw',
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  exit: {
    x: '100vw',
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
};

const NavInner = ({ mainNav, toggleDonate, setNavOpen }) => {
  useScrollFreeze();
  const [activeLinks, setActiveLinks] = useState('home');

  return (
    <motion.div
      variants={navVars}
      initial='closed'
      animate='open'
      exit='closed'
      className='px-gutter w-full h-full bg-black text-white fixed top-0 z-30 flex items-center md:text-left'>
      <AnimatePresence exitBeforeEnter>
        {activeLinks === 'home' ? (
          <motion.div
            key={activeLinks}
            variants={homeVars}
            initial='initial'
            animate='animate'
            exit='exit'
            className='px-4 mt-10 sm:mt-0  w-full'>
            {mainNav.map((obj, i) => {
              const { topLink, subLinks } = obj || {};
              return (
                <button
                  key={i}
                  onClick={() => setActiveLinks(i)}
                  className={`flex flex-row justify-between items-center w-full focus:outline-none ${
                    i !== 0 && 'mt-6'
                  }`}>
                  <div className='relative'>
                    <p className='text-xl leading-xl font-medium'>{topLink}</p>
                    {/* <span className="absolute top-0 -right-3 text-sm leading-sm font-medium">{subLinks.length}</span> */}
                  </div>
                  <Arrow white={true} />
                </button>
              );
            })}
            <Link
              to='/hanover-hall'
              className='mt-6 block text-xl leading-xl font-medium'>
              Hanover Hall
            </Link>
          </motion.div>
        ) : (
          <motion.div
            key={activeLinks}
            variants={linkVars}
            initial='initial'
            animate='animate'
            exit='exit'
            className='pl-4 w-full'>
            <div
              className={`flex flex-row items-start w-full focus:outline-none`}>
              <button
                onClick={() => setActiveLinks('home')}
                className='transform rotate-180 mt-3 focus:outline-none'>
                <Arrow white={true} />
              </button>

              <div className='ml-4 w-full'>
                <button
                  onClick={() => setActiveLinks('home')}
                  className='relative w-max mb-4 focus:outline-none'>
                  <p className='text-xl leading-xl font-medium'>
                    {mainNav[activeLinks].topLink}
                  </p>
                  {/* <span className="absolute top-0 -right-3 text-sm leading-sm font-medium">{mainNav[activeLinks].subLinks.length}</span> */}
                </button>
                {mainNav[activeLinks].subLinks.map((link, i) => {
                  if (link.linkText === 'News & Reviews') {
                    return (
                      <Link
                        className={`text-base leading-base font-medium block mt-3`}
                        key={i}
                        to={`/news`}>
                        {link.linkText}
                      </Link>
                    );
                  } else if (link.linkText === 'Events Calendar') {
                    return (
                      <Link
                        className={`text-base leading-base font-medium block mt-3`}
                        key={i}
                        to={`/events`}>
                        {link.linkText}
                      </Link>
                    );
                  }
                  return (
                    <PageLink
                      key={i}
                      className={`text-base leading-base font-medium block mt-3`}
                      {...link}
                    />
                  );
                })}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <div className="absolute bottom-4 left-0 px-gutter w-full">
        <div className="px-gutter space-y-2">
         
          <button className="btn-nav w-full scale-90" onClick={toggleDonate}>
            Donate Today
          </button>
          <Link
            to="/concert-series-subscription"
            className="btn-nav w-full inline-block scale-90"
            onClick={() => {
              setNavOpen(false);
            }}
          >
            Subscribe Now
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export const NavModal = ({ navOpen, mainNav, toggleDonate, setNavOpen }) => {
  return (
    <AnimatePresence exitBeforeEnter>
      {navOpen && (
        <NavInner
          key={navOpen}
          toggleDonate={toggleDonate}
          mainNav={mainNav}
          setNavOpen={setNavOpen}
        />
      )}
    </AnimatePresence>
  );
};
